import { WebContent } from '@/utils/config';
import axios from 'axios';
import authHeader from './auth-header';
class WebContentService {
    getData(tenant_id, tenant_code,query) {
        return axios.get(WebContent + 
            '?tenant_id=' + tenant_id + 
            '&tenant_code=' + tenant_code +
            '&search_by=code&search_query='+query,
            { headers: authHeader() });
    }
}

export default new WebContentService();